export default __webpack_public_path__ + "static/media/signal.6e2c9d7b.svg";